/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box } from 'chakra-v3';
import { Text } from '../../components/Text';

interface FeatureCardProps {
  title: string;
  description: string;
  className?: string;
  style?: React.CSSProperties;
}

export const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, className = '', style = {} }) => {
  return (
    <Box
      style={style}
      className={className}
      border="1px solid"
      borderColor="rgba(208, 208, 208, 0.25)"
      borderRadius="4px"
      p={{ base: 4, md: 6 }}
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      w="full"
      h="full"
    >
      <Text
        fontFamily="body"
        fontSize="16px"
        fontWeight="normal"
        lineHeight="1.6"
        color="#1a1a1a"
        whiteSpace="pre-wrap"
      >
        <Text as="span" fontWeight="bold">
          {title}
        </Text>
        {description && ` ${description}`}
      </Text>
    </Box>
  );
};
